import { DataGridPro, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, useGridApiRef } from "@mui/x-data-grid-pro";
import React, { useContext, useEffect, useState } from 'react';
import { DownOutlined, FileSearchOutlined, UpOutlined, } from '@ant-design/icons';
import SL_Button from '../../components/buttons/Button';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import { displayMessage } from '../../services/helper';
import ControlFilters from './ControlFilters'
import CreateControl from './CreateControl'
import DetailControl from './DetailControl'

import { CommentaryModal } from './CommentaryModal'

import control_grid_columns from './grid_columns/control_grid_columns'
import { DateTime } from 'luxon';
import moment from 'moment';

export default function ListControl() {
    const {setShowLoading, windowHeight, mobile_mode} = useContext(GeneralContext)


    const [control, setControl] = useState([])
    const [totalizer, setTotalizer] = useState(null)
    const [isTotalizerVisable, setIsTotalizerVisable] = useState(false)
    const [currentControl, setCurrentControl] = useState(null)
    const [currenComments, setCurrentComments] = useState(null)
    
    const [isModalCreateControlVisible, setIsModalCreateControlVisible] = useState(false)
    const [isModalDetailControlVisible, setIsModalDetailControlVisible] = useState(false)
    const [isModalCommentaryVisible, setIsModalCommentaryVisible] = useState(false)
    const [onlyFromGhostMonitor, setOnlyFromGhostMonitor] = useState(false)

    const gridRef = useGridApiRef()
    const DataGridProHeight = windowHeight * 0.7

    const GridHighTotalizerOn = mobile_mode ? '72.5%' : '95%'
    const GridHighTotalizerOff = mobile_mode ? '85%' : '100%'

    const gridRowHeight = 70


    const lastMoonday = DateTime.now().startOf('week').toJSDate()
    const nextFriday = DateTime.now().startOf('week').plus({ days: 5 }).endOf('day').toJSDate()
    const handleOnlyFromGhostMonitor = (e)=>{
        setOnlyFromGhostMonitor(e)
    }

    useEffect(
        () => {
            loadControlsData({
                start_date: moment(lastMoonday).format('YYYY-MM-DD'),
                end_date: moment(nextFriday).format('YYYY-MM-DD'),
            })
        },
        []
    )

    const loadControlsData = async (currentFilters) => {
        try {
            setShowLoading(true)

            const payload = { ...currentFilters, onlyFromGhostMonitor }
            const rs = await api.dialy_controls.listControl(payload)
            gridRef.current.setSelectionModel([])
            setControl(rs.data.controls)
            setTotalizer(rs.data.totalizers)
        } finally {
            setShowLoading(false)
        }
    }

    const handleRowChange = (e) => {
        setCurrentControl(e?.row)
    }

    const handleOnCloseModalCreateControl = () => {
        setIsModalCreateControlVisible(false)
    }

    const handleOnCloseModalDetailControl = () => {
        setCurrentComments([])
        setIsModalDetailControlVisible(false)
    }

    const handleOnOpenModalDetailControl = () => {
        setIsModalDetailControlVisible(true)
    }

    const renderCustomToolBar = () => {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport
                    csvOptions={{ 
                        delimiter: ';',
                        includeHeaders: true,
                        allColumns: true,
                    }}
                    onClick={
                        () => {
                            gridRef.setSelectionModel([])
                        }
                    }
                />
            </GridToolbarContainer>
        )
    }

    const handleDoubleClickOnRow = async (e) => {
        try {
            setShowLoading(true)
            setCurrentControl(e?.row)
        } finally {
            handleOnOpenModalDetailControl()
            setShowLoading(false)
        }
    }

    const handleCloseCommentModal = async => {
        setIsModalCommentaryVisible(false)
    }

    return (
        <>
            {
                isModalCreateControlVisible
                &&
                <CreateControl
                    isModalVisible={isModalCreateControlVisible}
                    handleOnCloseModal={handleOnCloseModalCreateControl}
                    refreshControls={loadControlsData}
                />
            }


            {
                isModalDetailControlVisible
                &&
                <DetailControl
                    isModalVisible={isModalDetailControlVisible}
                    handleOnCloseModal={handleOnCloseModalDetailControl}
                    control_id={currentControl?.id}
                    refreshControls={loadControlsData}
                    setIsModalCommentaryVisible={setIsModalCommentaryVisible}
                    currenComments={currenComments}
                    setCurrentComments={setCurrentComments}
                />
            }

            {
                isModalCommentaryVisible
                &&
                <CommentaryModal
                    isModalVisible={isModalCommentaryVisible}
                    handleOnCloseModal={handleCloseCommentModal}
                    currentControl={currentControl}
                    currenComments={currenComments}
                    setCurrentComments={setCurrentComments}

                />

            }

            <ControlFilters handleOnSearchControls={loadControlsData} lastMoonday={lastMoonday} nextFriday={nextFriday} handleOnlyFromGhostMonitor={handleOnlyFromGhostMonitor} />
            <div className='flex flex-col w-full'>

                <div style={{ height: DataGridProHeight, minHeight: 300 }} >

                    <div className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${mobile_mode ? `flex-col` : `flex-row`} `}>
                        <span className='self-center text-white flex-1 text-center font-medium'>{displayMessage('CONTROLS_HISTORY_OLD')}</span>
                        <div className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`} >
                            <SL_Button
                                type='default'
                                className='items-center w-30 flex'
                                disabled={!currentControl}
                                style={{ color: !currentControl ? 'grey' : null }}
                                onClick={handleOnOpenModalDetailControl}
                                icon={<FileSearchOutlined className='text-base text-green-900' />}
                            >
                                {displayMessage('DETAIL_CONTROL')}
                            </SL_Button>
                        </div>
                    </div>


                    <DataGridPro
                        rows={control}
                        apiRef={gridRef}
                        style={{ height: isTotalizerVisable ? GridHighTotalizerOn : GridHighTotalizerOff }}
                        columns={control_grid_columns}
                        pagination
                        pageSize={100}
                        components={{ Toolbar: renderCustomToolBar, }}
                        onRowClick={handleRowChange}
                        onRowDoubleClick={e => handleDoubleClickOnRow(e)}
                        density="compact"
                        disableMultipleSelection
                        rowHeight={gridRowHeight}
                    />

                    <div style={{ display: 'flex', flexDirection: 'column', marginTop: 15 }}>
                        <div className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 flex-row `}>
                            <span className='self-center text-white flex-1 text-center font-medium'>{displayMessage('TOTALIZERS')}</span>
                            <SL_Button
                                style={{ background: 'white', borderColor: 'darkblue', color: 'black', fontWeight: 'bold' }}
                                className='items-center w-30 flex'
                                onClick={() => { isTotalizerVisable ? setIsTotalizerVisable(false) : setIsTotalizerVisable(true) }}
                                shape="circle"
                                icon={isTotalizerVisable ? <UpOutlined /> : <DownOutlined />}
                            />
                        </div>
                        {
                            isTotalizerVisable &&

                            <div style={{ display: 'flex', flex: 1, flexDirection: mobile_mode ? 'column' : 'row', justifyContent: 'space-evenly', background: '#efefef', padding: 5, rowGap: mobile_mode && 3 }} >
                                <div style={{ display: 'flex', flex: mobile_mode && 1, flexDirection: 'row', width: !mobile_mode && '50%', justifyContent: 'space-evenly' }}>
                                    <div style={{ display: 'flex', backgroundColor: 'white', borderRadius: 5, flex: mobile_mode && 1 }}>
                                        <span style={{ marginRight: 8, marginLeft: 8, marginTop: 2, marginBottom: 2, fontWeight: 'bold' }}>{`${displayMessage('PRESENT_PERCENT')}  ${isNaN(totalizer?.presenceDaysPercent) ? ' - ' : totalizer?.presenceDaysPercent + '%'} `}</span>
                                    </div>

                                    <div style={{ display: 'flex', backgroundColor: 'white', borderRadius: 5, flex: mobile_mode && 1 }}>
                                        <span style={{ marginRight: 8, marginLeft: 8, marginTop: 2, marginBottom: 2, fontWeight: 'bold' }}>{`${displayMessage('MISSING_PERCENT')}  ${isNaN(totalizer?.missingDaysPercentage) ? ' - ' : totalizer?.missingDaysPercentage + '%'} `}</span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', flex: mobile_mode && 1, flexDirection: mobile_mode ? 'column' : 'row', width: !mobile_mode && '50%', justifyContent: 'space-evenly', rowGap: mobile_mode && 3 }}>
                                    <div style={{ display: 'flex', backgroundColor: 'white', borderRadius: 5 }}>
                                        <span style={{ marginRight: 8, marginLeft: 8, marginTop: 2, marginBottom: 2, fontWeight: 'bold' }}>{`${displayMessage('STARS_AVARGE')}  ${isNaN(totalizer?.averageStars) ? ' - ' : totalizer?.averageStars} `}</span>
                                    </div>

                                    <div style={{ display: 'flex', backgroundColor: 'white', borderRadius: 5 }}>
                                        <span style={{ marginRight: 8, marginLeft: 8, marginTop: 2, marginBottom: 2, fontWeight: 'bold' }}>{`${displayMessage('STARS_EXERCISE_AVARGE')}  ${isNaN(totalizer?.averageExerciseStars) ? ' - ' : totalizer?.averageExerciseStars} `}</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
